<template>
  <div class="background">
    <transition name="fade">
      <div v-if="outstandingItems.length">
        <div class="container pb-xxl">
          <h2 class="section-headline">
            Please return your clothes
          </h2>
          <p class="mb-md">
            Your membership is scheduled to end on {{ toMonthDayYearString(membershipDetails.scheduledCancelDate) }}, and we have not received your outstanding items. Items need to be shipped back by your membership end date to avoid further charges. If we do not receive your items within 2 weeks of your membership end date, you will be charged the full member price for the unreturned clothing.
          </p>
          <div class="bold">
            Changed your mind?
            <BaseButton
              class="mx-md mt-md"
              text="Rejoin"
              :to="{name: 'resume'}"/>
          </div>
          <div class="bold">
            Need a return label?
            <BaseButton
              v-if="fedexPreferred"
              class="mx-md mt-md"
              :to="printReturnLabelLink"
              text="Print Return Label"/>
            <BaseButton
              v-else
              small
              class="mx-md mt-md"
              text="Contact Support"
              @click="contactSupport"/>
          </div>
        </div>
        <div class="bg-origami pb-xxl">
          <div class="container">
            <h2 class="section-headline">
              Already returned your items?
            </h2>
            <p>Track the status of any items you’ve already dropped in the mail.</p>
            <BaseButton
              small
              type="router-link"
              :to="{ name: 'account', query: { section: 'shipping-returns' } }"
              class="mt-md"
              text="Return Status"/>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { toMonthDayYearString } from '@/utils/stringParsing.js'
import { useReturnCarrier } from '@/composables/returnCarrier'
import { useClientStore } from '@shared/stores/client'
import { useClosetStore } from '@shared/stores/closet.js'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'

const clientStore = useClientStore()
const { membershipDetails } = storeToRefs(clientStore)
const closetStore = useClosetStore()
const { outstandingItems } = storeToRefs(closetStore)
const { getPackageItems } = closetStore

const { fedexPreferred, printReturnLabelLink } = useReturnCarrier()

const contactSupport = () => {
  window.Intercom('showNewMessage')
}
onMounted(() => {
  getPackageItems()
})
</script>

<style lang="scss" scoped>
.background {
  height: 100vh;
}
</style>
